module.exports = __webpack_public_path__ + "static/media/privacypolicy.05cff1b4.htm";